import { render, staticRenderFns } from "./ProNotes.vue?vue&type=template&id=38438656&scoped=true"
import script from "./ProNotes.vue?vue&type=script&lang=js"
export * from "./ProNotes.vue?vue&type=script&lang=js"
import style0 from "./ProNotes.vue?vue&type=style&index=0&id=38438656&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38438656",
  null
  
)

export default component.exports